import ButtonGroup from "@visa/vds/button-group";
import ButtonText from "@visa/vds/button-text";
import { default as Dialog, default as dialog } from "@visa/vds/dialog";
import DialogCardBody from "@visa/vds/dialog-card-body";
import DialogCardFooter from "@visa/vds/dialog-card-footer";
import DialogCardHead from "@visa/vds/dialog-card-head";
import DialogCardHeadTitle from "@visa/vds/dialog-card-head-title";
import Fieldset from "@visa/vds/fieldset";
import Form from "@visa/vds/form";
import FormControl from "@visa/vds/form-control";
import Input from "@visa/vds/input";
import React, { useEffect, useMemo, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { FormHelper } from "../../../../_helpers/FormHelper";

const CategoryDialog = (props) => {
  const { control, handleSubmit, getValues, reset } = useForm({
    defaultValues: useMemo(() => {
      return props.category;
    }, [props]),
  });

  const [formData, setFormData] = useState(getValues());
  const updateFormData = () => setFormData(getValues());

  const handleClickCancel = () => {
    reset(props.category);
    props.setDialog({ ...props.dialog, open: !props.dialog.open });
  };

  const onSubmit = () => {
    let updateDto = formData;
    props.handleClickSave(props.alertObj, updateDto);
  };

  useEffect(() => {
    reset(props.category);
  }, [props.category]);

  return (
    <Dialog
      aria-describedby="dialog-description"
      onExit={() => props.setDialog({ open: false })}
      open={props.dialog.open}
      titleId="dialog-title"
    >
      <DialogCardHead style={{ width: "30vw" }}>
        <DialogCardHeadTitle id="dialog-title">
          {props.category.id === 0 ? "Add New Category" : "Edit Category"}
        </DialogCardHeadTitle>
      </DialogCardHead>
      <DialogCardBody id="dialog-description">
        <Form>
          <Fieldset>
            <FormControl>
              <Controller
                name="name"
                control={control}
                rules={{
                  required: true,
                  maxLength: 50,
                }}
                render={({ field, fieldState }) => (
                  <Input
                    value={field.value}
                    onChange={(e) => {
                      field.onChange(e);
                      updateFormData();
                    }}
                    maxLength="50"
                    label="Category Name"
                    ariaLabel="Category Name"
                    invalid={fieldState.invalid}
                    showErrorText={fieldState.invalid}
                    errorText={FormHelper.renderErrorMsg(fieldState.error)}
                  />
                )}
              />
            </FormControl>
          </Fieldset>
        </Form>
      </DialogCardBody>
      <DialogCardFooter>
        <ButtonGroup direction="right">
          <ButtonText
            colorScheme="primary"
            type="submit"
            onClick={handleSubmit(onSubmit)}
          >
            Save
          </ButtonText>
          <ButtonText colorScheme="secondary" onClick={handleClickCancel}>
            Cancel
          </ButtonText>
        </ButtonGroup>
      </DialogCardFooter>
    </Dialog>
  );
};
export default CategoryDialog;
